import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import './Events.css';

const MID_AUTUMN_DATE = '2026-09-25T18:00:00';

const BLESSINGS_LIST = [
  {
    wish: 'Chúc các em thiếu nhi luôn chăm ngoan, học giỏi và tràn ngập niềm vui trong tình thương của Chúa và gia đình!',
    verse: 'Cứ để trẻ em đến với Thầy, đừng ngăn cấm chúng, vì Nước Trời thuộc về những ai giống như chúng.',
    ref: 'Phúc Âm Mát-thêu 19, 14',
  },
  {
    wish: 'Nguyện xin tâm hồn tuổi thơ của các em luôn tinh tuyền, tỏa sáng rực rỡ và ấm áp như ánh trăng rằm.',
    verse: 'Chính anh em là ánh sáng cho trần gian... Ánh sáng của anh em phải chiếu giãi trước mặt thiên hạ.',
    ref: 'Phúc Âm Mát-thêu 5, 14.16',
  },
  {
    wish: 'Chúc gia đình bạn một mùa Trung Thu đoàn viên, tràn đầy bình an, sức khỏe và muôn ơn lành từ Thiên Chúa.',
    verse: 'Bình an cho anh em! Như Chúa Cha đã sai Thầy, thì Thầy cũng sai anh em.',
    ref: 'Phúc Âm Gio-an 20, 21',
  },
  {
    wish: 'Chúc đêm hội trăng rằm rộn rã tiếng cười, chan chứa niềm vui hiệp nhất và tình huynh đệ trong Xứ đoàn.',
    verse: 'Ngọt ngào tốt đẹp lắm thay, anh em được sống sum vầy bên nhau!',
    ref: 'Thánh Vịnh 133, 1',
  },
  {
    wish: 'Chúc bạn có một đêm rước đèn hân hoan, gặt hái thật nhiều hoa trái thiêng liêng và kỷ niệm tuổi thơ tươi đẹp!',
    verse: 'Hãy vui luôn trong niềm vui của Chúa. Tôi nhắc lại: anh em hãy vui lên!',
    ref: 'Thư Phi-líp-phê 4, 4',
  },
];

const Events = () => {
  const [isEnded, setIsEnded] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [hasClicked, setHasClicked] = useState(false);
  const [activeBlessing, setActiveBlessing] = useState(null);

  useEffect(() => {
    const targetDate = new Date(MID_AUTUMN_DATE).getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference <= 0) {
        setIsEnded(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setIsEnded(false);
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / (1000 * 60)) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleMakeWish = () => {
    if (hasClicked) return;

    setHasClicked(true);
    const selected = BLESSINGS_LIST[Math.floor(Math.random() * BLESSINGS_LIST.length)];
    setActiveBlessing(selected);
  };

  return (
    <div className="mid-autumn-page">
      <Navbar />

      <main className="mid-autumn-container">
        {/* Banner chính */}
        <header className="hero-banner">
          <div className="moon-decoration" aria-hidden="true">🌕</div>
          <div className="floating-lantern left" aria-hidden="true">🏮</div>
          <div className="floating-lantern right" aria-hidden="true">🏮</div>

          <div className="badge-parish">
            <span>TRƯỜNG GIÁO LÝ THIẾU NHI • GIÁO XỨ AN NHƠN</span>
          </div>
          <h1 className="main-title">ĐÊM HỘI TRĂNG RẰM</h1>
          <p className="subtitle">TẾT TRUNG THU 2026</p>
          <div className="theme-tag">Chủ đề: "Cùng Chúa đón trăng - Trở nên Ánh sáng"</div>
        </header>

        {/* Khối hiển thị: Chúc mừng (nếu đã tới giờ) hoặc Đồng hồ đếm ngược */}
        {isEnded ? (
          <section className="celebration-box">
            <div className="fireworks-icon">🎉 🏮 🥮 🏮 🎉</div>
            <h2 className="celebration-title">CHÚC MỪNG TẾT TRUNG THU!</h2>
            <p className="celebration-desc">
              Nguyện chúc Cha Chánh xứ, Cha Tuyên úy, quý Dì, quý Anh Chị Giáo lý viên,
              các bậc Phụ huynh cùng toàn thể các em Thiếu Nhi một đêm hội tràn ngập
              tiếng cười, ấm áp yêu thương và muôn vàn Hồng ân Thiên Chúa!
            </p>
            <div className="festive-stars">✨ 🌟 ✨ 🌟 ✨</div>
          </section>
        ) : (
          <section className="countdown-card">
            <div className="countdown-header">
              <span className="dot pulse" />
              <h3>ĐẾM NGƯỢC ĐẾN GIỜ KHAI HỘI</h3>
            </div>
            <div className="timer-grid">
              <div className="timer-segment">
                <span className="timer-value">{timeLeft.days}</span>
                <span className="timer-label">Ngày</span>
              </div>
              <div className="timer-segment">
                <span className="timer-value">{timeLeft.hours}</span>
                <span className="timer-label">Giờ</span>
              </div>
              <div className="timer-segment">
                <span className="timer-value">{timeLeft.minutes}</span>
                <span className="timer-label">Phút</span>
              </div>
              <div className="timer-segment">
                <span className="timer-value">{timeLeft.seconds}</span>
                <span className="timer-label">Giây</span>
              </div>
            </div>
            <p className="timer-note">Hẹn gặp tất cả các bạn nhỏ vào lúc 18:00 Thứ Sáu, ngày 25/09/2026!</p>
          </section>
        )}

        {/* Thẻ tóm tắt thông tin */}
        <section className="info-cards-grid">
          <div className="info-badge-card highlight-glow">
            <div className="badge-icon">⏰</div>
            <div>
              <h4>Thời Gian</h4>
              <p className="info-text-bold">18:00 | Thứ Sáu, ngày 25/09/2026</p>
              <p className="info-text-sub">(Tức Rằm tháng 8 Âm lịch)</p>
            </div>
          </div>

          <div className="info-badge-card">
            <div className="badge-icon">📍</div>
            <div>
              <h4>Địa Điểm</h4>
              <p className="info-text-bold">Thánh Đường & Sân Nhà Thờ</p>
              <p className="info-text-sub">Giáo Xứ An Nhơn</p>
            </div>
          </div>

          <div className="info-badge-card">
            <div className="badge-icon">🏮</div>
            <div>
              <h4>Lồng Đèn</h4>
              <p className="info-text-bold">BTC Phát Đèn & Tự Do Mang Theo</p>
              <p className="info-text-sub">Thiếu nhi có thể tự mang lồng đèn riêng</p>
            </div>
          </div>
        </section>

        {/* Lồng Đèn Thắp Sáng & Lời Chúa (Bấm 1 lần/lượt tải) */}
        <section className="interactive-lantern-section">
          <div className="lantern-widget-header">
            <h3>🏮 Thắp Đèn Nhận Lộc & Lời Chúa</h3>
            <p>Mỗi bạn nhỏ hãy chạm nhẹ vào lồng đèn một lần để thắp sáng và đón nhận câu Lời Chúa soi đường.</p>
          </div>

          <div className="interactive-box">
            <button
              type="button"
              className={`big-lantern-btn ${hasClicked ? 'lit disabled' : ''}`}
              onClick={handleMakeWish}
              disabled={hasClicked}
            >
              <span className="lantern-emoji">🏮</span>
              <span className="lantern-action-label">
                {hasClicked ? '✨ Đèn Đã Thắp Sáng (Đã nhận lộc)' : '👉 Chạm vào để Thắp Sáng Lồng Đèn'}
              </span>
            </button>

            {activeBlessing && (
              <div className="blessing-card-result">
                <div className="scripture-container">
                  <span className="scripture-badge">📖 LỜI CHÚA SOI SÁNG</span>
                  <blockquote className="scripture-quote">
                    "{activeBlessing.verse}"
                  </blockquote>
                  <cite className="scripture-source">— {activeBlessing.ref} —</cite>
                </div>

                <div className="wish-divider" />

                <div className="wish-message">
                  <span className="wish-tag">Lời Chúc Trung Thu:</span>
                  <p>{activeBlessing.wish}</p>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Chi tiết chương trình & Lưu ý */}
        <section className="events-detail-grid">
          <div className="detail-card">
            <h2>📜 Chương Trình Đêm Hội</h2>
            <div className="timeline-flow">
              <div className="timeline-step">
                <span className="step-time">18:00</span>
                <div className="step-body">
                  <strong>Thánh Lễ:</strong> Cầu nguyện bình an cho toàn thể thiếu nhi, quý phụ huynh, quý anh chị giáo lý viên và giáo xứ.
                </div>
              </div>

              <div className="timeline-step">
                <span className="step-time">18:45</span>
                <div className="step-body">
                  <strong>Phát Lồng Đèn:</strong> Ban tổ chức phát lồng đèn Trung Thu cho các em thiếu nhi và ổn định đội hình rước đèn.
                </div>
              </div>

              <div className="timeline-step">
                <span className="step-time">19:00</span>
                <div className="step-body">
                  <strong>Rước Đèn:</strong> Đoàn rước đèn lung linh sắc màu diễu hành quanh khuôn viên nhà thờ trong tiếng hát rộn ràng.
                </div>
              </div>

              <div className="timeline-step">
                <span className="step-time">19:15</span>
                <div className="step-body">
                  <strong>Chương Trình Văn Nghệ:</strong> Các tiết mục múa hát thiếu nhi, ảo thuật, biểu diễn lân sư rồng và hoạt cảnh Chị Hằng - Chú Cuội.
                </div>
              </div>

              <div className="timeline-step">
                <span className="step-time">20:00</span>
                <div className="step-body">
                  <strong>Phát Quà</strong> Trao tặng những phần quà bánh Trung Thu ý nghĩa cho các em thiếu nhi kết thúc đêm hội.
                </div>
              </div>
            </div>
          </div>

          <div className="detail-card reminders-card">
            <h2>🏮 Nhắn Nhủ Thiếu Nhi & Phụ Huynh</h2>
            <ul className="reminders-list">
              <li>
                <strong>Lồng đèn:</strong> <em>Thiếu nhi có thể tự mang lồng đèn</em> yêu thích của mình từ nhà đi để rước đèn thêm rực rỡ và đa dạng sắc màu.
              </li>
              <li>
                <strong>Trang phục:</strong> Đồng phục Thiếu nhi Thánh Thể hoặc trang phục lịch sự, gọn gàng để thuận tiện tham dự Thánh Lễ và rước đèn.
              </li>
              <li>
                <strong>An toàn:</strong> Ưu tiên dùng lồng đèn chạy pin hoặc đèn LED nhỏ; hạn chế đèn cầy tự chế để bảo đảm an toàn.
              </li>
              <li>
                <strong>Giữ gìn vệ sinh:</strong> Chung tay bảo vệ môi trường, vứt que đèn và vỏ bánh kẹo vào đúng nơi quy định sau giờ liên hoan.
              </li>
              <li>
                <strong>Đồng hành:</strong> Kính mời quý Phụ huynh cùng tham dự Thánh Lễ và chung vui đêm rằm cùng các con.
              </li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Events;